import React, { PropTypes } from 'react';
import InputError from './InputError.jsx';


class InputWithError extends React.Component {
  static propTypes = {
    touched: PropTypes.bool,
    error: PropTypes.string,
    placeholder: PropTypes.string,
    meta: PropTypes.shape({
      error: PropTypes.string,
      touched: PropTypes.bool,
    }).isRequired,
    input: PropTypes.object,
  };

  static defaultProps = {
    touched: false,
    error: '',
    placeholder: '',
    input: {},
  };

  componentWillUnmount() {
    const { input } = this.props;

    input.onChange('');
  }

  render() {
    const { input, meta, placeholder, error, ...props } = this.props;

    return (
      <div>
        <input {...input} placeholder={placeholder} {...props} />
        <div className="error-line">
          <InputError touched={meta.touched} error={error || meta.error} />
        </div>
      </div>
    );
  }
}

export default InputWithError;



/** WEBPACK FOOTER **
 ** ./js/components/shared/InputWithError.jsx
 **/